import React from 'react';

const Review = ({page}) => {
    return<div data-uk-lightbox><a href={page}><div className="cardBillionaireBuddha__image"><img src={page}/></div></a></div>;
    }

export default Review;
